export default function toString(x){return null==x?void 0:x.toString()}